<template>
    <div class="page-auth">
        <div class="register-page">
            <div class="hidden bg-spect lg:flex flex-col items-center justify-evenly">
                <img class="" src="../../assets/auth/images/spec-brand-white.svg" alt="cyberforceacademy logo" />
                <img class="" src="../../assets/auth/images/icon-auth-banner.svg" alt="cyberforceacademy logo" />

                <p class="text-white text-2xl text-center w-3/4 xl:w-full">
                    Placez l’humain au coeur de votre Stratégie de
                    <span class="text-accent">Cyberdéfense</span>
                </p>
            </div>

            <div class="content-form flex items-center justify-center py-4 bg-back">
                <div class="mx-auto w-4/5 md:w-3/4 bg-white py-8 px-3 rounded-15" v-if="!isMailSent">
                    <div class="grid gap-2 text-center">
                        <h1 class="text-4xl font-[500] text-spect">
                            Renvoyer le mail d'activation?
                        </h1>
                        <p class="text-balance">Entrez votre email</p>
                    </div>

                    <form @submit.prevent="resendActivationMail" class="grid gap-3 px-4">
                        <div class="form-group">
                            <label class="block font-medium text-gray-700 mb-1">E-mail
                            </label>
                            <input type="email"
                                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-[#d8d8d8] focus:border-transparent"
                                placeholder="Votre Adresse email" v-model="email" />
                        </div>

                        <!-- Submit Button -->
                        <button type="submit" :disabled="error || waitingAPIResponse"
                            class="w-full bg-spect text-white py-3 rounded-lg hover:bg-opacity-90 transition-colors">
                            <span v-if="waitingAPIResponse"
                                class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></span>
                            <span> Renvoyer le mail d'activation </span>
                        </button>

                        <!-- Login Link -->
                        <div class="text-center text-sm">
                            <span class="text-gray-600">Vous avez un compte? </span>
                            <a href="/" class="text-accent">Connectez-vous ici</a>
                        </div>
                    </form>
                </div>

                <!-- Mail sent -->
                <div class="mx-auto grid w-3/4 gap-6 bg-white py-8 px-3 rounded-15" v-else>
                    <div class="flex flex-col justify-center items-center gap-3">
                        <p class="text-3xl w-full text-center">Inscription terminee</p>
                        <video width="256" height="256" preload="none" style="
                background: transparent
                  url('https://cdn-icons-png.flaticon.com/512/8717/8717946.png')
                  50% 50% / fit no-repeat;
              " autoplay="autoplay" loop="true" muted="muted" playsinline="" class="">
                            <source src="https://cdn-icons-mp4.flaticon.com/512/8717/8717946.mp4" type="video/mp4" />
                        </video>
                        <label class="w-full text-center">Vérifiez votre boîte email pour activer votre compte.
                            Merci !</label>
                        <div class="text-center">
                            <span class="text-gray-600">J'ai pas reçu le mail&nbsp; </span>
                            <a class="text-accent cursor-pointer">Renvoyer le mail d'activation</a>
                        </div>
                        <div class="text-center text-sm">
                            <span class="text-gray-600">Vous avez un compte? </span>
                            <a href="/" class="text-accent">Connectez-vous ici</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import axios from "axios";
import { ref } from "vue";

const isMailSent = ref(false);
const email = ref("");
const error = ref(null);
const waitingAPIResponse = ref(false);

const validateEmail = () => {
    error.value = null;
    let isValid = true;
    if (!email.value || email.value.trim() == "") {
        error.value = "Le champ email est obligatoire.";
        isValid = false;
    }
    if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.value)
    ) {
        error.value = "Le champ email est invalide.";
        isValid = false;
    }
    return isValid;
};

const resendActivationMail = async () => {
    if (!validateEmail()) {
        return;
    }
    waitingAPIResponse.value = true;
    await axios
        .post(
            `${process.env.VUE_APP_BASE_URL}accounts/resend-email-activate-account/`,
            {
                email: email.value,
            }
        )
        .then((response) => {
            if (response.status == 200) {
                isMailSent.value = true;
            }
        })
        .catch((error) => {
            error.value = error.response.data.message;
            waitingAPIResponse.value = false;
        })
        .finally(() => {
            waitingAPIResponse.value = false;
        });
};
</script>

<style lang="scss" scoped>
@use "../../assets/scss/tailwinds.scss";
</style>
